<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card>
        <vx-card class="p-4" noShadow cardBorder>
          <div class="vx-row">
            <div class="w-full vx-col md:w-1/3 sm:w-1/2">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="w-full mb-4 md:mb-0" />
            </div>
          </div>
          <div class="mt-5 vx-row">
            <div class="w-full ml-auto vx-col">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <template slot="actions">
          <vs-button @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus"
            class="mr-4" color="primary" type="filled">create</vs-button>
        </template>
        <div id="incoterms-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="incoterms">
              <template slot="thead">
                <vs-th sort-key="code" width="10%">CODE</vs-th>
                <vs-th WIDTH="10%">CREATED DATE/TIME</vs-th>
                <vs-th width="10%">CREATED BY</vs-th>
                <vs-th width="10%">SCHEDULED TIMESTAMP</vs-th>
                <vs-th width="25%">SUBJECT</vs-th>
                <vs-th width="25%">NEXT ACTION</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdate(data[indextr].id)" class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].created_by_staff }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].scheduled_timestamp }}
                  </vs-td>

                  <vs-td :data="data[indextr].subject">
                    {{ data[indextr].subject || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].notes || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3" size="small" color="warning"
                          type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <create-customer-crm-contact-pop-up ref="createCustomerCrmContactPopUp" :customer_id="customerId" />
  </div>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import CreateCustomerCrmContactPopUp from '@/components/popups/crm/customer/contacts/CreateCustomerCrmContactPopUp.vue'

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
import { defaultPagination, perPageList } from "@/constants/config";

const CrmRepository = RepositoryFactory.get('crm');

export default {
  name: "CustomerCrmContactList",
  data() {
    return {
      incoterms: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      customerId: null,
    }
  },
  props: {
    contact_type: {
      type: String,
      default: 'email'
    }
  },
  components: {
    CreateCustomerCrmContactPopUp,
    'v-select': vSelect
  },
  methods: {
    async refreshData() {
      await this.fetchIncoterms()
      await this.$emit('refreshSummary')
    },
    async fetchIncoterms() {
      await this.$vs.loading({
        container: '#incoterms-table',
        scale: 0.45
      })
      try {
        const { data } = await CrmRepository.getListOfCustomerContacts(this.customerId, this.page, this.filterQuery + `&filter[type]=${this.contact_type}`, this.perPage)
        this.incoterms = data.data
        this.meta = data.meta
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close('#incoterms-table > .con-vs-loading')
    },
    async onClickAdd() {
      await this.$refs.createCustomerCrmContactPopUp.openPopup(this.contact_type)
    },
    async onClickUpdate(id) {
      await this.$refs.createCustomerCrmContactPopUp.openPopup(this.contact_type, id)
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params) {

    },
    filterQueryUpdate() {
      this.fetchIncoterms()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchIncoterms()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchIncoterms()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  async mounted() {
    this.customerId = this.$route.params.id
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchIncoterms()
    },
    perPage() {
      this.fetchIncoterms()
    }
  }
}
</script>
  
<style scoped></style>
  